<template lang="pug">
section.gu24-popup
  .gu24-popup__close(@click="close")
  header.gu24-popup__header
    slot(name="title")
  section
    slot
</template>

<script>
export default {
  props: {
    noReflection: {
      type: String,
      required: false,
      default: 'gu24-popup',
    },
    closeOnOutside: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  beforeDestroy() {
    this.rm();
  },
  deactivated() {
    this.rm();
  },
  mounted() {
    this.add();
  },
  methods: {
    click(e) {
      if (!this.findPapa(e.target)) {
        this.$emit('close', null);
      }
    },
    add() {
      if (this.closeOnOutside) {
        document.addEventListener('click', this.click);
      }
    },
    rm() {
      document.removeEventListener('click', this.click);
    },
    findPapa(target) {
      if (target.nodeName.match(/^body$/gi)) {
        return false;
      }
      return (target.classList.value.match('gu24-popup') ||
        target.classList.value.match(this.noReflection)) ? true : this.findPapa(target.parentNode);
    },
    close(e) {
      this.$emit('close', e);
    },
  },
};
</script>

<style lang="scss">
.gu24-popup {
  max-width: 60%; // 475
  padding: 40 / 16 + rem; // 40px
  position: absolute;
  right: 0;
  top: 60 / 16 + rem; // 60px
  background: #fff;
  box-shadow: 0 4 / 16 + rem 8 / 16 + rem 0 rgba(0, 0, 0, 0.14);
  z-index: 111111;
  &__header {
    font-size: 12 / 16 + rem; // 12px
    font-weight: 700; // bold
    letter-spacing: 0.075em; // = 75 in ps
    text-transform: uppercase;
    margin-bottom: 20 / 16 + rem;
  }
  &__close {
    user-select: none;

    cursor: pointer;
    position: absolute;
    top: 10 / 16 + rem;
    right: 10 / 16 + rem;
    width: 32 / 16 + rem;
    height: 32 / 16 + rem;

    background-image: url('./p_cls.svg');
    background-size: 12 / 16 + rem;
    background-position: center;
    background-repeat: no-repeat;
    transition: transform .25s ease;
    &:hover {
      transform: rotate(90deg);
    }
  }
}

.white.gu24-popup {
  top: 120 / 16 + rem;
}
</style>
